import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserFunction } from '../entities/user-functions.entity';
import { UserService } from '../services/user.service';

export enum UserFunctionCheck {
    HasAny,
    HasAll
}
@Injectable({
    providedIn: 'root'
})
export abstract class UserFunctionGuard {
    protected redirectUrl = '/';

    protected abstract FUNCTIONS_TO_CHECK: UserFunction[];

    protected abstract USER_FUNCTION_CHECK: UserFunctionCheck;

    constructor(
        protected userService: UserService,
        protected router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<true | UrlTree> {
        return this.checkFunctions(this.FUNCTIONS_TO_CHECK).pipe(
            map(isAllowed => {
                if (!isAllowed) {
                    console.error(`User does not have functions required to access ${state.url} page`);

                    return this.router.createUrlTree([this.redirectUrl]);
                }

                return true;
            })
        );
    }

    checkFunctions(userFunctionsToCheck: UserFunction[]): Observable<boolean> {
        return this.USER_FUNCTION_CHECK === UserFunctionCheck.HasAll
            ? this.userService.hasUserFunctions(userFunctionsToCheck)
            : this.userService.hasAnyUserFunction(userFunctionsToCheck);
    }

    hasAccess(): Observable<boolean> {
        return this.checkFunctions(this.FUNCTIONS_TO_CHECK);
    }
}
